import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { RouterModule } from '@angular/router';

import { CurrentCountryModule } from '@app/src/app/components/CurrentCountry';
import { LogoModule } from '@app/src/app/components/Logo';
import { NaviconModule } from '@app/src/app/components/Navicon';
import { MgDirectivesModule } from '@app/src/app/directives';
import { MgAvatarModule } from '@app/src/app/elements/MgAvatar';
import { MgPersonMinimalModule } from '@app/src/app/elements/MgPersonMinimal';
import { FtueHighlightPipeModule } from '@app/src/app/ftue/Highlight/pipes/FtueHighlight';
import { MgIconModule } from '@app/src/app/icon';
import { NavLinkModule } from '@app/src/app/navigation/components/NavLink';
import { NavigationDrawerSubNavModule } from '@app/src/app/navigation/components/NavigationDrawerSubNav';
import { PermissionsModule } from '@app/src/app/permissions';

import { FormModule } from '@shared/components/form';

import { NavigationDrawerComponent } from './NavigationDrawer.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgAvatarModule,
    MgPersonMinimalModule,
    LogoModule,
    MgIconModule,
    NaviconModule,
    CurrentCountryModule,
    FtueHighlightPipeModule,
    NavLinkModule,
    NavigationDrawerSubNavModule,
    PermissionsModule,
    MgDirectivesModule,
    FormModule,

    // External dependencies
    CommonModule,
    RouterModule,
    MatExpansionModule,
    MatListModule,
  ],
  declarations: [NavigationDrawerComponent],
  exports: [NavigationDrawerComponent],
})
export class NavigationDrawerModule {}
